import { createAction } from 'redux-actions';
import { instance } from "../../../config/interceptor";

export const cleanupAction = createAction('CLEANUP_ADD_CLASSIFICATION');

export const cleanup = ()  => async (dispatch) => {
  dispatch(cleanupAction());
}

export const addClassificationRequest = createAction('ADD_CLASSIFICATION_REQUEST');
export const addClassificationSuccess = createAction('ADD_CLASSIFICATION_SUCCESS');
export const addClassificationError = createAction('ADD_CLASSIFICATION_ERROR');

export const addClassification = (request) => async (dispatch) => {
  try {
    dispatch(addClassificationRequest());
    const resp = await instance.post(`/v1/Classification/Post`, request);

    dispatch(addClassificationSuccess(resp.data));
  } catch (e) {
    if(e.response && e.response.data && e.response.data.description)
      dispatch(addClassificationError(e.response.data.description));
    else
      dispatch(addClassificationError(e.message));
  }
};
